import { selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import { deleteHashQuery, setHashQuery } from '@zcode/nr/es/shared/packages/history-middleware'
import { hocCompose } from '@zcode/react-utils'
import { withRouter } from '@zcode/router-utils'
import type { MODAL_TYPE, State } from '@zcode/state-type'
import type { Location } from 'history'
import { connect } from 'react-redux'
import { selectOpen } from '../../modules/modals/selectors/index'
import type { Dispatch } from '../../modules/types'
import { ModalWrapper, type ModalWrapperProps } from './ModalWrapper'

interface ModalWrapperContainerProps {
  location: Location<unknown>
  type: MODAL_TYPE
}

const mapStateToProps = (state: State, { type }: ModalWrapperContainerProps) => {
  return {
    isMobile: selectIsMobile(state),
    open: selectOpen(state, type),
  } satisfies Partial<ModalWrapperProps>
}

function last<T extends readonly string[]>(
  array: T
): T extends [...string[], infer Last] ? Last : T[number] {
  // @ts-expect-error TS can't tell that this produces the last item in the array
  return array[array.length - 1]
}

export function getModalName(type: MODAL_TYPE) {
  return last(type.split('/')).toLowerCase()
}

const mapDispatchToProps = (dispatch: Dispatch, { location, type }: ModalWrapperContainerProps) => {
  const modalName = getModalName(type)

  return {
    onClose: () => {
      if (location.hash === `#modal=${modalName}`) {
        dispatch(deleteHashQuery({ key: 'modal' }))
      }
    },
    onOpen: () => {
      dispatch((_, getState) => {
        const state = getState()
        const isMobile = selectIsMobile(state)
        // append the hash only if we don't have hash already because cause troubles with stacking modals
        if (isMobile && modalName && (!location.hash || location.hash.startsWith('#modal='))) {
          dispatch(setHashQuery({ key: 'modal', value: modalName }))
        }
      })
    },
  } satisfies Partial<ModalWrapperProps>
}

export const ModalWrapperContainer = hocCompose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  ModalWrapper
)
